// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"996f4efa","703":"f3c45f05"}[chunkId] + ".chunk.js";
};